import { z } from 'zod';

const providerSchema = z.object({ id: z.string().min(1), label: z.string().min(1) });

const configSchema = z.object({
  environment: z.string(),
  apiBaseUrl: z.string().default('/api/v1'),
  auth: z.discriminatedUnion('mode', [
    z.object({ mode: z.literal('dev') }),
    z.object({
      mode: z.literal('cognito'),
      authority: z.url(),
      clientId: z.string().min(1),
      domain: z.string().min(1),
      providers: z.array(providerSchema).default([]),
    }),
  ]),
});

export type RuntimeConfig = z.infer<typeof configSchema>;

/** Environment values are served as /config.json by the deployment, never baked into the bundle. */
export async function loadRuntimeConfig(): Promise<RuntimeConfig> {
  const res = await fetch('/config.json', { cache: 'no-store' });
  if (!res.ok) throw new Error(`config.json ${res.status}`);
  return configSchema.parse(await res.json());
}
